import { render, staticRenderFns } from "./formListaEmbarque.vue?vue&type=template&id=2acdf81c&scoped=true"
import script from "./formListaEmbarque.vue?vue&type=script&lang=js"
export * from "./formListaEmbarque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdf81c",
  null
  
)

export default component.exports